"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      d: "M12 16.158c1.598-1.301 2.808-2.555 3.63-3.76.822-1.206 1.232-2.335 1.232-3.388 0-.908-.165-1.682-.497-2.322-.332-.64-.742-1.159-1.23-1.555a4.79 4.79 0 0 0-1.58-.864C12.988 4.089 12.47 4 12.001 4c-.469 0-.987.09-1.554.269a4.786 4.786 0 0 0-1.583.864c-.488.396-.898.915-1.23 1.555-.332.641-.498 1.416-.498 2.324 0 1.052.411 2.18 1.233 3.386.822 1.205 2.032 2.459 3.63 3.76Zm0 2.418a1.76 1.76 0 0 1-.547-.087 1.681 1.681 0 0 1-.498-.26 25.971 25.971 0 0 1-4.187-4.17c-1.27-1.581-1.906-3.264-1.906-5.047 0-1.203.217-2.26.65-3.169.434-.91.99-1.67 1.67-2.282a6.887 6.887 0 0 1 2.294-1.377A7.412 7.412 0 0 1 12 1.725c.833 0 1.674.153 2.524.459.85.306 1.614.765 2.294 1.377.68.612 1.236 1.373 1.67 2.282.433.91.65 1.966.65 3.17 0 1.782-.636 3.465-1.906 5.046a25.975 25.975 0 0 1-4.187 4.17 1.684 1.684 0 0 1-.497.26c-.178.058-.36.087-.547.087ZM12 11a2.06 2.06 0 0 0 1.511-.626 2.06 2.06 0 0 0 .627-1.512 2.06 2.06 0 0 0-.627-1.51A2.06 2.06 0 0 0 12 6.724a2.06 2.06 0 0 0-1.511.626 2.06 2.06 0 0 0-.627 1.511c0 .59.21 1.094.627 1.512A2.06 2.06 0 0 0 12 11ZM6 22.275c-.32 0-.589-.11-.808-.33a1.095 1.095 0 0 1-.33-.808c0-.319.11-.588.33-.808.22-.22.489-.329.808-.329h12c.32 0 .589.11.808.33.22.219.33.488.33.808 0 .319-.11.588-.33.808-.22.22-.489.329-.808.329H6Z"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};